export default __webpack_public_path__ + "static/media/img_filterNoData_facebook.ed57cab2.svg";